export default "/images/import_stock.png?fdd655eb2dc0d43b2552c9ae123c0377";